export const mapToArabic = (value) => {
  const mapping = {
    'new': { text: 'جديد', color: 'blue' },
    'preparing': { text: 'جارى التحضير', color: 'orange' },
    'printing': { text: 'طباعة', color: 'purple' },
    'pressing': { text: 'تكبيس', color: 'teal' },
    'wrapping': { text: 'تغليف', color: 'rose' },
    'out for delivery': { text: 'خرج للتوصيل', color: 'brown' },
    'delivered': { text: 'تم التوصيل', color: 'green' },
    'cancelled': { text: 'تم الالغاء', color: 'red' },
    'quran': { text: 'آيات قرآنية' },
    'art': { text: 'طابع فنى' },
    'kids': { text: 'أطفال' },
    'cold': { text: 'باردة' },
    'warm': { text: 'دافئة' },
    'matte': { text: 'مط' },
    'gloss': { text: 'لامع' },
    'cash on delivery': { text: 'نقدا عند الإستلام' },
    'credit card': { text: 'بطاقة ائتمان' },
  };
  
  return mapping[value] || value;
};